<ul class="pagination">
  <li class="page-item" *ngIf="showLeftEllipsis">
    <a class="page-link" (click)="goToPrevBlock()">...</a>
  </li>

  <li *ngFor="let currentPage of pages" 
    class="page-item" 
    [class.active]="currentPage === page"
  >
    <a class="page-link" (click)="selectPage(currentPage)">
      {{ currentPage }}
    </a>
  </li>
  
  <li class="page-item" *ngIf="showRightEllipsis">
    <a class="page-link" (click)="goToNextBlock()">...</a>
  </li>
</ul>